import React from 'react';
import { useTranslation } from '@/i18n';

interface FlagProps {
  width?: number;
  height?: number;
  className?: string;
}

export const ChinaFlag: React.FC<FlagProps> = ({ width = 24, height = 16, className = '' }) => {
  const { t } = useTranslation();
  const ariaLabelKey = 'common.flags.china';
  const ariaLabel = t(ariaLabelKey);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={ariaLabel === ariaLabelKey ? 'China Flag' : ariaLabel}
    >
      {/* Red background */}
      <rect width="24" height="16" fill="#EE1C25" />
      
      {/* Large star */}
      <path
        d="M6 3L6.618 5.236L8.472 3.382L7.236 5.618L9.472 6L7.236 6.382L8.472 8.618L6.618 6.764L6 9L5.382 6.764L3.528 8.618L4.764 6.382L2.528 6L4.764 5.618L3.528 3.382L5.382 5.236L6 3Z"
        fill="#FFFF00"
      />
      
      {/* Small star 1 (top) */}
      <path
        d="M10 2L10.247 2.753L10.854 2.146L10.494 2.988L11.336 2.628L10.494 3.235L11.336 3.472L10.247 3.472L10 4.225L9.753 3.472L8.664 3.472L9.506 3.235L8.664 2.628L9.506 2.988L9.146 2.146L9.753 2.753L10 2Z"
        fill="#FFFF00"
      />
      
      {/* Small star 2 */}
      <path
        d="M12 4L12.247 4.753L12.854 4.146L12.494 4.988L13.336 4.628L12.494 5.235L13.336 5.472L12.247 5.472L12 6.225L11.753 5.472L10.664 5.472L11.506 5.235L10.664 4.628L11.506 4.988L11.146 4.146L11.753 4.753L12 4Z"
        fill="#FFFF00"
      />
      
      {/* Small star 3 */}
      <path
        d="M12 7L12.247 7.753L12.854 7.146L12.494 7.988L13.336 7.628L12.494 8.235L13.336 8.472L12.247 8.472L12 9.225L11.753 8.472L10.664 8.472L11.506 8.235L10.664 7.628L11.506 7.988L11.146 7.146L11.753 7.753L12 7Z"
        fill="#FFFF00"
      />
      
      {/* Small star 4 (bottom) */}
      <path
        d="M10 9L10.247 9.753L10.854 9.146L10.494 9.988L11.336 9.628L10.494 10.235L11.336 10.472L10.247 10.472L10 11.225L9.753 10.472L8.664 10.472L9.506 10.235L8.664 9.628L9.506 9.988L9.146 9.146L9.753 9.753L10 9Z"
        fill="#FFFF00"
      />
    </svg>
  );
};

export default ChinaFlag;
